"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TileLoader_1 = require("../TileLoader");
var AnnotationTypes_1 = require("./AnnotationTypes");
var formats_1 = require("../../formats");
var Formats_1 = require("../../formats/Formats");
var axios_1 = require("axios");
var AnnotationFormat;
(function (AnnotationFormat) {
    AnnotationFormat[AnnotationFormat["ValisGenes"] = 0] = "ValisGenes";
    AnnotationFormat[AnnotationFormat["BigBed"] = 1] = "BigBed";
})(AnnotationFormat || (AnnotationFormat = {}));
var AnnotationTileLoader = /** @class */ (function (_super) {
    __extends(AnnotationTileLoader, _super);
    function AnnotationTileLoader(dataSource, model, contig, tileSize) {
        if (tileSize === void 0) { tileSize = 1 << 20; }
        var _this = _super.call(this, tileSize, 1) || this;
        _this.dataSource = dataSource;
        _this.model = model;
        _this.contig = contig;
        _this.annotationFileFormat = null;
        _this.macroLod = 5;
        _this.macroLodBlendRange = 2;
        _this.macroLodThresholdLow = 7;
        _this.macroLodThresholdHigh = _this.macroLodThresholdLow + _this.macroLodBlendRange;
        _this._bigLoaderPromise = null;
        _this.annotationFileFormat = AnnotationTileLoader.getAnnotationFormat(model);
        return _this;
    }
    AnnotationTileLoader.cacheKey = function (model) {
        return model.path;
    };
    AnnotationTileLoader.getAnnotationFormat = function (model) {
        // determine annotation file format
        if (model.path != null) {
            var format = Formats_1.Formats.determineFormat(model.path);
            switch (format) {
                case Formats_1.GenomicFileFormat.ValisGenes:
                    return AnnotationFormat.ValisGenes;
                case Formats_1.GenomicFileFormat.BigBed:
                    return AnnotationFormat.BigBed;
                default:
                    // we have to guess
                    if (/bigbed/ig.test(model.path)) {
                        return AnnotationFormat.BigBed;
                    }
                    else if (/vdna/ig.test(model.path)) {
                        return AnnotationFormat.ValisGenes;
                    }
                    else {
                        return AnnotationFormat.BigBed;
                    }
            }
        }
        return null;
    };
    AnnotationTileLoader.getAvailableContigs = function (model) {
        var contigs = new Array();
        var format = this.getAnnotationFormat(model);
        if (format != null) {
            switch (format) {
                case AnnotationFormat.ValisGenes:
                    if (model.path != null) {
                        return axios_1.default.get(model.path + '/manifest.json')
                            .then(function (response) {
                            // create a manifest that lists the available contigs
                            contigs = contigs.concat(response.data.contigs);
                        })
                            .catch(function (reason) {
                            console.error("Error loading manifest: " + reason);
                        }).then(function (_) { return contigs; });
                    }
                    break;
                case AnnotationFormat.BigBed:
                    if (model.path != null) {
                        return formats_1.UCSCBig.getBigLoader(model.path).then(function (b) { return formats_1.UCSCBig.getContigs(b.header); });
                    }
                    break;
            }
        }
        return Promise.resolve(contigs);
    };
    AnnotationTileLoader.prototype.mapLodLevel = function (l) {
        if (l < this.macroLod) {
            return 0;
        }
        else {
            return this.macroLod;
        }
    };
    AnnotationTileLoader.prototype.getBigLoader = function () {
        if (this._bigLoaderPromise == null) {
            this._bigLoaderPromise = formats_1.UCSCBig.getBigLoader(this.model.path);
        }
        return this._bigLoaderPromise;
    };
    AnnotationTileLoader.prototype.getTilePayload = function (tile) {
        var _this = this;
        var isMacro = tile.lodLevel >= this.macroLod;
        if (this.model.path != null) {
            switch (this.annotationFileFormat) {
                case AnnotationFormat.ValisGenes: {
                    // using path override
                    return AnnotationTileLoader.loadValisGenesAnnotations(this.model.path, this.contig, tile.x, tile.span, isMacro).then(transformAnnotationsValisGene);
                }
                case AnnotationFormat.BigBed: {
                    return this.getBigLoader().then(function (loader) {
                        var e_1, _a;
                        // THIS ONLY WORKS IF WE'RE NOT USING ZOOM LEVELS:
                        // if the data has already been loaded into a higher LOD tile then we can just get it from there
                        // we can happily take all entries that cross the tiles span because the deduplication is done in the track renderer
                        var macroTile = _this.getTileAtLod(tile.x + tile.span * 0.5, _this.macroLod, false);
                        if (macroTile.state === TileLoader_1.TileState.Complete) {
                            // extract intersecting genes
                            var intersectingGenes = new Array();
                            try {
                                for (var _b = __values(macroTile.payload), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var gene = _c.value;
                                    var notOverlapping = ((gene.startIndex + gene.length) < tile.x) || (gene.startIndex > (tile.x + tile.span));
                                    if (!notOverlapping) {
                                        intersectingGenes.push(gene);
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            return intersectingGenes;
                        }
                        else {
                            return loader.reader.readBigBedData(_this.contig, tile.x, _this.contig, tile.x + tile.span).then(transformAnnotationsBigBed);
                        }
                        /*
                        let zoomIndex: number | null  = loader.lodZoomIndexMap[tile.lodLevel];

                        if (zoomIndex == null || true) {
                            return loader.reader.readBigBedData(this.contig, tile.x, this.contig, tile.x + tile.span).then(transformAnnotationsBigBed);
                        } else {
                            // I haven't found a file in the wild where using zoom index tiles actually helps
                            // we lose strand information so the macro/micro transition doesn't feel great
                            // it's useful if macro tiles require lots of data but so far that doesn't seem to be the case
                            console.log('BigBED using zoomIndex', zoomIndex);
                            return loader.reader.readZoomData(
                                this.contig,
                                tile.x,
                                this.contig,
                                tile.x + tile.span,
                                zoomIndex
                            ).then(transformAnnotationsBigZoom);
                        }
                        */
                    });
                }
                default: {
                    return [];
                }
            }
        }
        else {
            return this.dataSource.loadAnnotations(this.contig, tile.x, tile.span, isMacro).then(transformAnnotationsValisGene);
        }
    };
    AnnotationTileLoader.loadValisGenesAnnotations = function (path, contig, startBaseIndex, span, macro) {
        var jsonPath = path + "/" + contig + (macro ? '-macro' : '') + "/" + startBaseIndex + "," + span + ".json";
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            // disable caching (because of common browser bugs)
            request.open('GET', jsonPath, true);
            request.responseType = 'json';
            request.onloadend = function () {
                if (request.status >= 200 && request.status < 300) {
                    // success-like response
                    resolve(request.response);
                }
                else {
                    // error-like response
                    reject("HTTP request error: " + request.statusText + " (" + request.status + ")");
                }
            };
            request.send();
        });
    };
    return AnnotationTileLoader;
}(TileLoader_1.TileLoader));
exports.AnnotationTileLoader = AnnotationTileLoader;
function transformAnnotationsBigBed(dataset) {
    return dataset.map(function (data) {
        var gene = {
            type: AnnotationTypes_1.GenomeFeatureType.Gene,
            name: data.name === '.' ? undefined : data.name,
            startIndex: data.start,
            length: data.end - data.start,
            strand: data.strand,
            class: AnnotationTypes_1.GeneClass.Unspecified,
            soClass: 'gene',
            transcriptCount: 0,
            transcripts: [{
                    type: AnnotationTypes_1.GenomeFeatureType.Transcript,
                    startIndex: data.start,
                    length: data.end - data.start,
                    class: AnnotationTypes_1.TranscriptClass.Unspecified,
                    soClass: 'transcript',
                    exon: data.exons == null ? [] : data.exons.map(function (exon) {
                        var transcriptComponent = {
                            type: AnnotationTypes_1.GenomeFeatureType.TranscriptComponent,
                            startIndex: exon.start,
                            length: exon.end - exon.start,
                            class: AnnotationTypes_1.TranscriptComponentClass.Exon,
                            soClass: 'exon'
                        };
                        return transcriptComponent;
                    }),
                    cds: [],
                    utr: [],
                    other: [],
                }],
            score: data.score
        };
        return gene;
    });
}
function transformAnnotationsBigZoom(dataset) {
    return dataset.map(function (data) {
        var gene = {
            type: AnnotationTypes_1.GenomeFeatureType.Gene,
            name: undefined,
            startIndex: data.start,
            length: data.end - data.start,
            strand: AnnotationTypes_1.Strand.None,
            class: AnnotationTypes_1.GeneClass.Unspecified,
            soClass: 'gene',
            transcriptCount: 0,
            transcripts: [],
        };
        return gene;
    });
}
function transformAnnotationsValisGene(flatFeatures) {
    // convert flat list of features into a nested structure which is easier to work with for rendering
    var payload = new Array();
    var activeGene;
    var activeTranscript;
    var lastType = -1;
    for (var i = 0; i < flatFeatures.length; i++) {
        var feature = flatFeatures[i];
        // validate feature type conforms to expected nesting order
        var deltaType = feature.type - lastType;
        if (deltaType > 1) {
            console.warn("Invalid gene feature nesting: " + AnnotationTypes_1.GenomeFeatureType[lastType] + " -> " + AnnotationTypes_1.GenomeFeatureType[feature.type]);
        }
        lastType = feature.type;
        if (feature.type === AnnotationTypes_1.GenomeFeatureType.Gene) {
            var geneInfo = feature;
            activeGene = __assign({}, geneInfo, { transcripts: [] });
            payload.push(activeGene);
        }
        if (feature.type === AnnotationTypes_1.GenomeFeatureType.Transcript) {
            var transcriptInfo = feature;
            if (activeGene == null) {
                console.warn("Out of order Transcript \u2013 no parent gene found");
                continue;
            }
            activeTranscript = __assign({}, transcriptInfo, { exon: [], cds: [], utr: [], other: [] });
            activeGene.transcripts.push(activeTranscript);
        }
        if (feature.type === AnnotationTypes_1.GenomeFeatureType.TranscriptComponent) {
            var componentInfo = feature;
            if (activeTranscript == null) {
                console.warn("Out of order TranscriptComponent \u2013 no parent transcript found");
                continue;
            }
            // bucket components by class
            switch (componentInfo.class) {
                case AnnotationTypes_1.TranscriptComponentClass.Exon: {
                    activeTranscript.exon.push(componentInfo);
                    break;
                }
                case AnnotationTypes_1.TranscriptComponentClass.ProteinCodingSequence: {
                    // validate CDS ordering (must be startIndex ascending)
                    var lastCDS = activeTranscript.cds[activeTranscript.cds.length - 1];
                    if (lastCDS != null && (lastCDS.startIndex >= componentInfo.startIndex)) {
                        console.warn("Out of order CDS \u2013 Protein coding components must be sorted by startIndex");
                    }
                    activeTranscript.cds.push(componentInfo);
                    break;
                }
                case AnnotationTypes_1.TranscriptComponentClass.Untranslated: {
                    activeTranscript.utr.push(componentInfo);
                    break;
                }
                default: {
                    activeTranscript.other.push(componentInfo);
                    break;
                }
            }
        }
    }
    return payload;
}
exports.default = AnnotationTileLoader;
